const roles = {
  ADMIN: 'admin',
  PROJECT_MANAGER: 'projectManager',
};

export default roles;
